import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useContent } from "@/context/ContentContext";
import { useLang } from "@/context/LanguageContext";

const TEXT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "La presente Privacy Policy descrive come Salty Folks Surf Club raccoglie e tratta i dati personali degli utenti del sito.",
      "Dati raccolti: quando effettui una prenotazione raccogliamo nome, cognome, email, numero di telefono ed eventuali note. Questi dati sono utilizzati esclusivamente per gestire la tua prenotazione e contattarti in merito alla lezione.",
      "Base giuridica: il trattamento è basato sull'esecuzione del servizio richiesto e sul consenso dell'utente.",
      "Conservazione: i dati sono conservati per il tempo necessario alla gestione delle prenotazioni e agli obblighi di legge.",
      "Diritti dell'utente: puoi richiedere in qualsiasi momento l'accesso, la rettifica o la cancellazione dei tuoi dati scrivendo ai nostri contatti.",
      "Questo è un testo provvisorio e potrà essere aggiornato con la versione legale definitiva.",
    ],
  },
  cookie: {
    title: "Cookie Policy",
    body: [
      "Questo sito utilizza cookie tecnici necessari al corretto funzionamento della piattaforma.",
      "Cookie tecnici: utilizzati per garantire la navigazione e le funzionalità di base, incluse le sessioni di accesso al pannello di gestione.",
      "Cookie di terze parti: la mappa di Google Maps incorporata può installare cookie di terze parti soggetti alle rispettive policy.",
      "Puoi gestire o disabilitare i cookie tramite le impostazioni del tuo browser.",
      "Questo è un testo provvisorio e potrà essere aggiornato con la versione legale definitiva.",
    ],
  },
};

export default function LegalPage({ type }) {
  const t = TEXT[type] || TEXT.privacy;
  const { content } = useContent();
  const { L } = useLang();

  return (
    <div className="min-h-screen bg-sand-100" data-testid={`legal-page-${type}`}>
      <header className="bg-ocean-900 py-5">
        <div className="max-w-3xl mx-auto px-5 sm:px-6 flex items-center justify-between">
          <Link to="/"><Logo variant="light" className="h-10 w-auto" /></Link>
          <Link to="/" className="flex items-center gap-2 text-sand-100/80 hover:text-gold text-sm font-mono">
            <ArrowLeft className="w-4 h-4" /> HOME
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 sm:px-6 py-16">
        <h1 className="font-heading text-3xl sm:text-4xl font-extrabold uppercase text-ocean mb-8">{t.title}</h1>
        {t.body.map((p, i) => (
          <p key={i} className="text-ocean/70 leading-relaxed mb-5">{p}</p>
        ))}
        <p className="text-ocean/50 text-sm mt-10">
          Salty Folks Surf Club · {L(content?.location?.address)} · {content?.contact?.email}
        </p>
      </main>
    </div>
  );
}
